// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"InviteFriendsPane__bodyContainer__eNAHx","content":"InviteFriendsPane__content__mLke2","imageWrapper":"InviteFriendsPane__imageWrapper__7bi4q"};